import { Navigate, useLocation } from 'react-router';
import { RequireResource } from './guards';
import { HubPage } from './HubPage';
import { routeResources, type FeatureRoute } from './registry';

/** Resolve former tab links before the hub guard, then apply the destination's own permissions. */
export function FeaturePage({ route }: { route: FeatureRoute }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tab = params.get('tab');
  const destination = tab && route.movedTabs && Object.hasOwn(route.movedTabs, tab) ? route.movedTabs[tab] : undefined;
  if (destination) {
    params.delete('tab');
    const search = params.toString();
    return <Navigate to={{ pathname: destination, search: search ? `?${search}` : '', hash: location.hash }} replace />;
  }

  const Page = route.component;
  return <RequireResource resource={routeResources(route)}>{route.tabs ? <HubPage route={route} /> : Page ? <Page /> : null}</RequireResource>;
}
